export const ANY = "";
export const EXCEL = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
export const PDF = "application/pdf";